/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StornoReasonItemDto,
    StornoReasonItemDtoFromJSON,
    StornoReasonItemDtoFromJSONTyped,
    StornoReasonItemDtoToJSON,
} from './StornoReasonItemDto';

/**
 * 
 * @export
 * @interface AdminChurnDto
 */
export interface AdminChurnDto {
    /**
     * Number of users with past due subscription status
     * @type {number}
     * @memberof AdminChurnDto
     */
    pastDueUsers: number;
    /**
     * Number of users who have set a cancellation reason
     * @type {number}
     * @memberof AdminChurnDto
     */
    usersWithStornoReason: number;
    /**
     * Breakdown of cancellation reasons
     * @type {Array<StornoReasonItemDto>}
     * @memberof AdminChurnDto
     */
    stornoReasonsBreakdown: Array<StornoReasonItemDto>;
}

export function AdminChurnDtoFromJSON(json: any): AdminChurnDto {
    return AdminChurnDtoFromJSONTyped(json, false);
}

export function AdminChurnDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminChurnDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pastDueUsers': json['pastDueUsers'],
        'usersWithStornoReason': json['usersWithStornoReason'],
        'stornoReasonsBreakdown': ((json['stornoReasonsBreakdown'] as Array<any>).map(StornoReasonItemDtoFromJSON)),
    };
}

export function AdminChurnDtoToJSON(value?: AdminChurnDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pastDueUsers': value.pastDueUsers,
        'usersWithStornoReason': value.usersWithStornoReason,
        'stornoReasonsBreakdown': ((value.stornoReasonsBreakdown as Array<any>).map(StornoReasonItemDtoToJSON)),
    };
}

